import React from 'react';
import Badge from '../../../../generic/Utils/Badge';
import navigationEventTracker from '../tracker/navigationEventTracker';
import clsx from 'clsx';

const SimpleNavItem = ({
  label,
  url,
  iconClass,
  active,
  trackingInfo,
  badgeInfo,
  displayOptions,
  openInNewTab,
  tabClass,
}) => {
  const redirectToTab = () => {
    navigationEventTracker(trackingInfo);
  };

  const hiddenClass = displayOptions.hideOnWeb
    ? getDisplayOptions.hiddenOnWeb
    : displayOptions.hideOnMobile
      ? getDisplayOptions.hiddenOnMobileBlock
      : '';

  return (
    <div className={ hiddenClass }>
      <a
        tabIndex={ 0 }
        href={ url }
        className={ clsx("navitem", { "navitem-active": active }, tabClass) }
        onClick={ redirectToTab }
        target={ openInNewTab ? "_blank" : undefined }
      >
        <i className={ clsx("fa-regular fa-lg fa-fw", iconClass) } />
        <span className="nav-title">{ label }</span>
        { badgeInfo?.text && (
          <div className="nav-badge">
            <Badge typeClass={ badgeInfo.htmlClass } text={ badgeInfo.text } />
          </div>
        )}
      </a>
    </div>
  );
};

export default SimpleNavItem;
